// src/components/Skills.js
import React from "react";
import { Code, Server, Cpu, Briefcase, ChevronRight } from "lucide-react";
import SectionTitle from "./shared/SectionTitle";
import resumeData from "../data/resumeData";

const Skills = () => {
	const { skills } = resumeData;

	return (
		<section className="max-w-6xl mx-auto">
			<SectionTitle>Technical Skills</SectionTitle>
			<div className="grid md:grid-cols-2 gap-6 lg:gap-8">
				{/* Programming Languages */}
				<div className="bg-white border border-slate-200/80 shadow-card rounded-2xl p-8 transition-all duration-300 hover:shadow-lift hover:-translate-y-1">
					<div className="flex items-center mb-6">
						<div className="w-12 h-12 rounded-xl bg-brand-50 ring-1 ring-brand-100 flex items-center justify-center mr-4">
							<Code className="text-brand-600" size={24} />
						</div>
						<h3 className="text-xl font-bold text-slate-900">
							Programming Languages
						</h3>
					</div>
					<div className="flex flex-wrap gap-2">
						{skills.languages.map((lang, index) => (
							<span
								key={index}
								className="bg-brand-50 text-brand-700 ring-1 ring-brand-100 px-3.5 py-1.5 rounded-full text-sm font-medium"
							>
								{lang}
							</span>
						))}
					</div>
				</div>

				{/* Developer Tools */}
				<div className="bg-white border border-slate-200/80 shadow-card rounded-2xl p-8 transition-all duration-300 hover:shadow-lift hover:-translate-y-1">
					<div className="flex items-center mb-6">
						<div className="w-12 h-12 rounded-xl bg-emerald-50 ring-1 ring-emerald-100 flex items-center justify-center mr-4">
							<Server className="text-emerald-600" size={24} />
						</div>
						<h3 className="text-xl font-bold text-slate-900">
							Developer Tools
						</h3>
					</div>
					<div className="flex flex-wrap gap-2">
						{skills.developerTools.map((tool, index) => (
							<span
								key={index}
								className="bg-emerald-50 text-emerald-700 ring-1 ring-emerald-100 px-3.5 py-1.5 rounded-full text-sm font-medium"
							>
								{tool}
							</span>
						))}
					</div>
				</div>

				{/* Physical Tools */}
				<div className="bg-white border border-slate-200/80 shadow-card rounded-2xl p-8 transition-all duration-300 hover:shadow-lift hover:-translate-y-1">
					<div className="flex items-center mb-6">
						<div className="w-12 h-12 rounded-xl bg-violet-50 ring-1 ring-violet-100 flex items-center justify-center mr-4">
							<Cpu className="text-violet-600" size={24} />
						</div>
						<h3 className="text-xl font-bold text-slate-900">
							Physical Tools
						</h3>
					</div>
					<div className="flex flex-wrap gap-2">
						{skills.physicalTools.map((tool, index) => (
							<span
								key={index}
								className="bg-violet-50 text-violet-700 ring-1 ring-violet-100 px-3.5 py-1.5 rounded-full text-sm font-medium"
							>
								{tool}
							</span>
						))}
					</div>
				</div>

				{/* Awards & Certifications */}
				<div className="bg-white border border-slate-200/80 shadow-card rounded-2xl p-8 transition-all duration-300 hover:shadow-lift hover:-translate-y-1">
					<div className="flex items-center mb-6">
						<div className="w-12 h-12 rounded-xl bg-amber-50 ring-1 ring-amber-100 flex items-center justify-center mr-4">
							<Briefcase className="text-amber-600" size={24} />
						</div>
						<h3 className="text-xl font-bold text-slate-900">
							Awards & Certifications
						</h3>
					</div>
					<ul className="space-y-2 mb-6">
						{skills.awards.map((award, index) => (
							<li key={index} className="flex items-start text-slate-600">
								<ChevronRight
									className="text-brand-500 mt-1 mr-2 flex-shrink-0"
									size={16}
								/>
								<span>{award}</span>
							</li>
						))}
					</ul>
					<div className="flex flex-wrap gap-2">
						{skills.other.map((item, index) => (
							<span
								key={index}
								className="bg-amber-50 text-amber-700 ring-1 ring-amber-100 px-3.5 py-1.5 rounded-full text-sm font-medium"
							>
								{item}
							</span>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};

export default Skills;
